"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsEnum = void 0;
var OptionsEnum;
(function (OptionsEnum) {
    OptionsEnum["uniqueId"] = "uniqueId";
    OptionsEnum["fallback"] = "fallback";
    OptionsEnum["fallbackValue"] = "fallbackValue";
    OptionsEnum["defaultGenericError"] = "defaultGenericError";
    OptionsEnum["submitThrowsError"] = "submitThrowsError";
    OptionsEnum["showErrorsOnInit"] = "showErrorsOnInit";
    OptionsEnum["showErrorsOnSubmit"] = "showErrorsOnSubmit";
    OptionsEnum["showErrorsOnBlur"] = "showErrorsOnBlur";
    OptionsEnum["showErrorsOnChange"] = "showErrorsOnChange";
    OptionsEnum["showErrorsOnClear"] = "showErrorsOnClear";
    OptionsEnum["showErrorsOnReset"] = "showErrorsOnReset";
    OptionsEnum["validateOnInit"] = "validateOnInit";
    OptionsEnum["validateOnSubmit"] = "validateOnSubmit";
    OptionsEnum["validateOnBlur"] = "validateOnBlur";
    OptionsEnum["validateOnChange"] = "validateOnChange";
    OptionsEnum["validateOnChangeAfterInitialBlur"] = "validateOnChangeAfterInitialBlur";
    OptionsEnum["validateOnChangeAfterSubmit"] = "validateOnChangeAfterSubmit";
    OptionsEnum["validateDisabledFields"] = "validateDisabledFields";
    OptionsEnum["validateDeletedFields"] = "validateDeletedFields";
    OptionsEnum["validatePristineFields"] = "validatePristineFields";
    OptionsEnum["validateTrimmedValue"] = "validateTrimmedValue";
    OptionsEnum["validateOnClear"] = "validateOnClear";
    OptionsEnum["validateOnReset"] = "validateOnReset";
    OptionsEnum["strictSet"] = "strictSet";
    OptionsEnum["strictUpdate"] = "strictUpdate";
    OptionsEnum["strictDelete"] = "strictDelete";
    OptionsEnum["strictSelect"] = "strictSelect";
    OptionsEnum["softDelete"] = "softDelete";
    OptionsEnum["retrieveOnlyDirtyFieldsValues"] = "retrieveOnlyDirtyFieldsValues";
    OptionsEnum["retrieveOnlyEnabledFieldsValues"] = "retrieveOnlyEnabledFieldsValues";
    OptionsEnum["retrieveOnlyEnabledFieldsErrors"] = "retrieveOnlyEnabledFieldsErrors";
    OptionsEnum["retrieveNullifiedEmptyStrings"] = "retrieveNullifiedEmptyStrings";
    OptionsEnum["removeNullishValuesInArrays"] = "removeNullishValuesInArrays";
    OptionsEnum["preserveDeletedFieldsValues"] = "preserveDeletedFieldsValues";
    OptionsEnum["autoTrimValue"] = "autoTrimValue";
    OptionsEnum["autoParseNumbers"] = "autoParseNumbers";
    OptionsEnum["validationDebounceWait"] = "validationDebounceWait";
    OptionsEnum["validationDebounceOptions"] = "validationDebounceOptions";
    OptionsEnum["stopValidationOnError"] = "stopValidationOnError";
    OptionsEnum["validationPluginsOrder"] = "validationPluginsOrder";
    OptionsEnum["resetValidationBeforeValidate"] = "resetValidationBeforeValidate";
    OptionsEnum["applyInputConverterOnInit"] = "applyInputConverterOnInit";
    OptionsEnum["applyInputConverterOnSet"] = "applyInputConverterOnSet";
    OptionsEnum["applyInputConverterOnUpdate"] = "applyInputConverterOnUpdate";
})(OptionsEnum = exports.OptionsEnum || (exports.OptionsEnum = {}));
//# sourceMappingURL=OptionsModel.js.map